<!-- 【画面名】投票企画終了画面 -->

<template>
  <CommonHeader />
  <div id="entry-terminate" class="entry-terminate">

    <div class="content">
      <div class="message-area">
        <p class="full-text" v-if="fullText" v-html='fullText'></p>

        <p class="bottom-text">
          <span class="bottom-text-before" v-if="frontLinkText" v-html='frontLinkText'></span>
          <a class="fixed-link-text" v-if="linkName" v-html='linkName' v-bind:href="linkUrl"></a>
          <span class="bottom-text-after" v-if="rearLinkText" v-html='rearLinkText'></span>
        </p>

        <div id="errtext" class="errmsg" v-if="errorMessage" v-html='errorMessage'></div>

      </div>

      <div class="foot-text" v-if="bottomText" v-html='bottomText'></div>
    </div>
    <!-- /.content -->

  </div>
  <CommonFooter />
</template>

<script>
/* eslint-disable */
import CommonHeader from './CommonHeader.vue'
import CommonFooter from './CommonFooter.vue'

export default {
  name: 'EntryTerminate',
  components: {
    CommonHeader,
    CommonFooter,
  },
  data() {
    return {
      fullText: '',
      frontLinkText: '',
      linkName: '',
      linkUrl: '',
      rearLinkText: '',
      bottomText: '',
      errorMessage: '',
    }
  },
  inject: ['voteScreanInfo', 'getReservedWord'],
  mounted(){ // ページが読み込まれたらする処理
    // console.log(this.providedData[0].basic_info);
    //
    var displayInfo = this.voteScreanInfo[0].display_info;
    var voteEndInformation = displayInfo.vote_end_information;

    if(!voteEndInformation) return false;

    // 上部下部テキスト設置
    this.fullText = this.getReservedWord(voteEndInformation.vpes_full_text);
    this.frontLinkText = voteEndInformation.vpes_front_link_text;
    this.linkName = voteEndInformation.vpes_link_name;
    this.linkUrl = voteEndInformation.vpes_link_url;
    this.rearLinkText = voteEndInformation.vpes_rear_link_text;
    this.bottomText = this.getReservedWord(voteEndInformation.vpes_bottom_text);
  },
  // watch: {
    // voteScreanInfo(voteScreanInfo) {
      // console.log(voteScreanInfo);
    // },
  // }
}
/* eslint-disable */
</script>

